<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.sf_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="sf_sccode">
            <label class="weui-form-preview__label">{{customLabel.sf_sccode || "服务合同编号"}}</label>
            <em class="weui-form-preview__value">{{form.main.sf_sccode}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sf_custname">
            <label class="weui-form-preview__label">{{customLabel.sf_custname || "客户名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.sf_custname}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sf_currency">
            <label class="weui-form-preview__label">{{customLabel.sf_currency || "币种"}}</label>
            <em class="weui-form-preview__value">{{form.main.sf_currency}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sf_amount">
            <label class="weui-form-preview__label">{{customLabel.sf_amount || "金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(form.main.sf_amount,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sf_orcode">
            <label class="weui-form-preview__label">{{customLabel.sf_orcode || "发票编号"}}</label>
            <em class="weui-form-preview__value">{{form.main.sf_orcode}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sf_remark">
            <label class="weui-form-preview__label">{{customLabel.sf_remark || "备注"}}</label>
            <em class="weui-form-preview__value">{{form.main.sf_remark}}</em>
          </div>
        </custom-layout>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <router-link
        :to="'/crm/serve_fee_edit?id=' + form.main.id"
        v-if="form.main.sf_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="form.main.sf_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="form.main.sf_status == '已审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="form.main.sf_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout
  },
  data() {
    return {
      baseUrl: "/api/sale/servefee",
      codeField: "sf_code",
      caller: "ServeFee",
      xtype: "make-servefee-formpanel",
    };
  },
  methods: {
    p_remove() {
      const me = this

      me.$weui.confirm('确定删除单据？', function () {
        me.$loading({
          url: `/api/sale/servefee/delete/${me.form.main.id}?caller=ServeFee`,
          method: "POST"
        }).then(res => {
          if(res.success) {
            me.$router.back()
          }
        })
      });
    }
  }
};
</script>